const baseStyle = {
  fontFamily: 'body',
  m: 0,
};

export default {
  baseStyle,
};
